<template>
  <div>

    <van-loading size="50px" color="#ffffff" v-if="flag">保存中...</van-loading>

    <van-nav-bar
      title="添加收货地址"
      right-text="保存"
      left-arrow
      @click-right="onClickRight"
      @click-left="onClickLeft"

    />
    <van-cell-group class='margintop'>
      <van-field
        v-model="addressInfo.name"
        clearable
        label="收货人"
        placeholder="请输入收货人"
      />

      <van-field
        v-model="addressInfo.phone"
        type="number"
        label="手机号"
        placeholder="请输入手机号码"
      />
      <van-field
        v-model="ssqadr"
        readonly
        label="所在地区"
        placeholder="请选择省市区"
        @click="showarear"
      />
      <van-field
        v-model="addressInfo.address"
        type="textarea"
        label="详细地址"
        rows="1"
        autosize
        placeholder="请输入详细地址"
      />
    </van-cell-group>
    <div class="moren">
      <van-cell value="设为默认地址">
      </van-cell>
      <van-switch class="defaultadr"
                  v-model="addressInfo.status"
                  active-value="1"
                  inactive-value="0"
                  active-color="#CC0001"
                  size="30px"
      />
    </div>

    <div class="shanchu" style="margin-top: 0.3rem;" @click="deleteadr"
         v-if="addressInfo.address_id!=''">
      <van-cell value="删除收货地址">
      </van-cell>
    </div>

    <van-popup v-model="areashow" position="bottom">
      <van-area :area-list="areaList" :value="addressInfo.code" :item-height="46" @confirm="confirm"
                @cancel="hidearea"/>
    </van-popup>
  </div>

</template>

<script>
  import Vue from 'vue'
  import {Field} from 'vant'

  Vue.use(Field)
  import {Cell, CellGroup} from 'vant'

  Vue.use(Cell).use(CellGroup)
  import {Popup} from 'vant'

  Vue.use(Popup)
  import areaData from '@/public/area.js'  // areaData
  import {Area} from 'vant'

  Vue.use(Area)
  import {Switch} from 'vant'

  Vue.use(Switch)
  import {NavBar} from 'vant'

  Vue.use(NavBar)
  import {Dialog} from 'vant'

  Vue.use(Dialog)

  import {Loading} from 'vant';

  Vue.use(Loading)

  export default {
    data() {
      return {
        ssqadr: '',
        arearvalue: '',
        areashow: false,
        id: '',  // 编辑的时候有一个详情ID
        type: '',  // 页面类型，add 是添加 edit 是编辑
        areaList: areaData,  // 省市区数据
        addressInfo: {  // 地址信息初始值
          address_id: '',
          name: '',  // 姓名
          phone: '',  // 手机号
          province: '',
          city: '',
          district: '',
          address: '',
          status: '0',
          user_id: localStorage.getItem('user_id'),
          code: '140902'
        },

        flag: false
      }
    },
    created() {
      console.log('进来' + this.$route.query.addreid)
      if (this.$route.query.addreid != '' && this.$route.query.addreid != undefined) {
        console.log('进来')
        this.addressInfo.address_id = this.$route.query.addreid
        this.getadrbyadrid()
      }
    },
    methods: {
      // 删除地址
      deleteadr() {
        let that = this
        Dialog.confirm({
          message: '确认删除地址吗'
        }).then(() => {
          that.$http.api.deladr({
            address_id: that.addressInfo.address_id
          }).then(result => {
            that.$createToast({
              txt: '删除成功',
              type: 'txt'
            }).show()
            setTimeout(function () {
              that.$router.go(-1)
            }, 2000)
          })
        })
      },
      //获取根据地址id获取地址
      getadrbyadrid() {
        this.$http.api.getadrbyid({
          address_id: this.addressInfo.address_id
        }).then(result => {
          this.addressInfo = result
          this.ssqadr = this.addressInfo.province + this.addressInfo.city + this.addressInfo.district
          this.addressInfo.status = this.addressInfo.status.toString()
          this.$forceUpdate()
        })
      },
      // 添加地址按钮
      onClickRight() {
        let that = this
        if (that.addressInfo.name == '') {
          that.$createToast({
            txt: '收货人不能为空',
            type: 'txt'
          }).show()
        } else if (that.addressInfo.phone == '') {
          that.$createToast({
            txt: '手机号码不能为空',
            type: 'txt'
          }).show()
        } else if (that.addressInfo.district == '') {
          that.$createToast({
            txt: '所在地区不能为空',
            type: 'txt'
          }).show()
        } else if (that.addressInfo.address == '') {
          that.$createToast({
            txt: '详细地址不能为空',
            type: 'txt'
          }).show()
        } else {
          that.$http.api.addadr(
            that.addressInfo
          ).then(result => {
            // that.$createToast({
            //   txt: that.addressInfo.address_id != '' ? '修改成功' : '添加成功',
            //   type: 'txt'
            // }).show()
            this.flag = true
            setTimeout(function () {
              console.log(this)
              that.$router.go(-1)
            }, 2000)
          })
        }
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      // 显示地区
      showarear() {
        this.areashow = true
      },
      hidearea() {
        this.areashow = false
      },
      // 确认地区
      confirm(event) {
        console.log(event)
        let that = this
        that.addressInfo.code = event[2].code
        that.ssqadr = event[0].name + event[1].name + event[2].name
        that.areashow = false
        that.addressInfo.province = event[0].name
        that.addressInfo.city = event[1].name
        that.addressInfo.district = event[2].name
      }
    }
  }
</script>

<style>
  .van-picker__cancel, .van-picker__confirm, .van-dialog__confirm, .van-dialog__confirm:active {
    color: #E85C00;
  }

  .shanchu .van-cell__value--alone {
    color: #DB262D;
  }

  .van-nav-bar .van-icon {
    color: #4B4B4C;
  }

  .van-nav-bar__text {
    color: #E85C00;
  }

  .van-loading {
    position: fixed;
    width: 100%;
    height: 100%;
    padding: 45vh 0 0;
    background: rgba(0, 0, 0, .2);
    z-index: 1000;
    text-align: center;
  }

  .van-loading .van-loading__text {
    font-size: 0.45rem;
    color: #FFFFFF;
  }

</style>

<style scoped>
  .margintop {
    margin-top: 0.1rem;
  }

  .moren {
    position: relative;
    margin-top: 0.16rem;
  }

  .moren .defaultadr {
    position: absolute;
    right: 5%;
    top: 0px;
    bottom: 0px;
    margin: auto;
  }

</style>
